"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 68.92 24",
    width: "68.92",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m68.14 0h-67.34a.78.78 0 0 0 -.8.79v15.65a.78.78 0 0 0 .56.75l3.42 1v5a.78.78 0 1 0 1.56 0v-4.56l3.58 1h.22 25.13a.78.78 0 0 0 0-1.56h-25l-7.89-2.21v-14.29h65.78v16.57h-5.29a.78.78 0 0 0 0 1.56h6.07a.78.78 0 0 0 .78-.78v-18.13a.78.78 0 0 0 -.78-.79z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m48.21 16.18a3.91 3.91 0 1 0 3.91 3.91 3.91 3.91 0 0 0 -3.91-3.91zm2.35 3.91a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m57 16.18a3.91 3.91 0 1 0 3.91 3.91 3.91 3.91 0 0 0 -3.91-3.91zm2.35 3.91a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.34 2.36z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m39.43 16.18a3.91 3.91 0 1 0 3.91 3.91 3.91 3.91 0 0 0 -3.91-3.91zm2.35 3.91a2.35 2.35 0 1 1 -2.35-2.36 2.35 2.35 0 0 1 2.35 2.36z"
  })));
};

exports["default"] = _default;